import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useSystemStore } from 'stores/system'
import { useUserAuthStore } from 'stores/user/auth'

export const WELCOME_OFFER_BANNER_KEY = 'olimpbet_welcome_offer_banner_hide'
export const WELCOME_OFFER_POST_REG_KEY = 'olimpbet_welcome_offer_postreg_modal_hide' // default true

const SELECTED_WELCOME_OFFER_PATH = '/auth/api/v1/users/selected-welcome-offer'
const WELCOME_OFFER_BY_API_VALUE = {
  wo_gambling: 'casino',
  wo_sport: 'sport',
}
const AUTH_PLATFORM_BY_OFFER = {
  casino: 'gambling_gambling',
  sport: 'gambling_sport_web',
}

export const OFFERS = [
  {
    type: 'casino',
    titleKey: 'welcomeOffer.casinoOffer',
  },
  {
    type: 'sport',
    titleKey: 'welcomeOffer.sportOffer',
  },
]

const isSelectionModalOpen = ref(false)
const selectedOffer = ref('casino')
const postRegistrationOffer = ref(null)

export function resolveSelectedWelcomeOffer(value) {
  return WELCOME_OFFER_BY_API_VALUE[value] ?? null
}

export function getWelcomeOfferAuthPlatform(offer) {
  return AUTH_PLATFORM_BY_OFFER[offer] ?? 'gambling'
}

export async function fetchSelectedWelcomeOffer() {
  if (!process.env.AUTH_LINK) {
    return null
  }

  const response = await fetch(new URL(SELECTED_WELCOME_OFFER_PATH, process.env.AUTH_LINK).toString(), {
    method: 'GET',
    credentials: 'include',
    headers: {
      Accept: 'application/json, text/plain, */*',
      'Accept-Language': 'en-US,en;q=0.9',
    },
  })

  if (!response.ok) {
    throw new Error(`Selected welcome offer request failed with status ${response.status}`)
  }

  const data = await response.json()
  return resolveSelectedWelcomeOffer(data?.selected_welcome_offer)
}

export function useWelcomeOffer() {
  const { getAuth } = storeToRefs(useUserAuthStore())
  const { altW } = storeToRefs(useSystemStore())
  const route = useRoute()

  const hideBanner = ref(localStorage?.getItem(WELCOME_OFFER_BANNER_KEY) === 'true')
  const hidePostRegModal = ref(localStorage?.getItem(WELCOME_OFFER_POST_REG_KEY) === 'true')

  const routeName = computed(() => route.name)
  const isGamePage = computed(() => routeName.value === 'GamePageNew')

  watch(
    hideBanner,
    (newVal) => {
      localStorage?.setItem(WELCOME_OFFER_BANNER_KEY, newVal)
    },
    { flush: 'sync' },
  )

  watch(
    hidePostRegModal,
    (newVal) => {
      localStorage?.setItem(WELCOME_OFFER_POST_REG_KEY, newVal)
    },
    { flush: 'sync' },
  )

  const showBanner = computed({
    get() {
      return !getAuth.value && altW.value && !isGamePage.value && !hideBanner.value
    },
    set(newVal) {
      hideBanner.value = !newVal
    },
  })

  const showPostRegModal = computed({
    get() {
      return getAuth.value && altW.value && !hidePostRegModal.value
    },
    set(newVal) {
      hidePostRegModal.value = !newVal
    },
  })

  async function loadPostRegistrationOffer() {
    postRegistrationOffer.value = await fetchSelectedWelcomeOffer()
    return postRegistrationOffer.value
  }

  return {
    showBanner,
    showPostRegModal,
    isSelectionModalOpen,
    selectedOffer,
    postRegistrationOffer,
    loadPostRegistrationOffer,
  }
}
